import { z } from 'zod';
// Schemas Zod pour validation
export const casqueSchema = z.enum(['vert', 'orange', 'rouge']);
export const reponseValeurSchema = z.enum(['oui', 'non', 'nsp', 'nc']);
export const axeHaltesSchema = z.enum(['H', 'A', 'LT', 'E', 'S']);
export const questionnaireSchema = z.enum(['Q1', 'Q2']);
export const metierSchema = z.object({
    id: z.string(),
    code: z.string(),
    nom: z.string(),
    description: z.string().optional(),
    risques: z.array(z.string())
});
export const themeSchema = z.object({
    id: z.string(),
    code: z.string(),
    nom: z.string(),
    description: z.string().optional(),
    ordre: z.number()
});
export const questionSchema = z.object({
    id: z.string(),
    code: z.string(),
    themeId: z.string(),
    axe: axeHaltesSchema.optional(),
    libelle: z.string(),
    aide: z.string().optional(),
    ordre: z.number(),
    questionnaire: questionnaireSchema
});
export const solutionSchema = z.object({
    id: z.string(),
    code: z.string(),
    questionId: z.string().optional(),
    axe: axeHaltesSchema.optional(),
    type: z.enum(['technique', 'organisationnelle', 'humaine']),
    titre: z.string(),
    description: z.string(),
    priorite: z.number()
});
export const entrepriseSchema = z.object({
    id: z.string(),
    siret: z.string().optional(),
    raisonSociale: z.string(),
    effectif: z.number().optional(),
    metierId: z.string().optional()
});
export const diagnosticSchema = z.object({
    id: z.string(),
    entrepriseId: z.string(),
    metierId: z.string(),
    statut: z.enum(['en_cours', 'termine']),
    dateDebut: z.coerce.date(),
    dateFin: z.coerce.date().optional()
});
export const reponseSchema = z.object({
    id: z.string(),
    diagnosticId: z.string(),
    questionId: z.string(),
    valeur: reponseValeurSchema,
    commentaire: z.string().optional()
});
export const scoresAxesSchema = z.object({
    H: z.number(),
    A: z.number(),
    LT: z.number(),
    E: z.number(),
    S: z.number()
});
export const distributionSchema = z.object({
    oui: z.number(),
    non: z.number(),
    nsp: z.number(),
    nc: z.number()
});
export const resultatSchema = z.object({
    id: z.string(),
    diagnosticId: z.string(),
    casque: casqueSchema,
    scoreGlobal: z.number(),
    scoresAxes: scoresAxesSchema,
    distribution: distributionSchema
});
export const referentielVersionSchema = z.object({
    version: z.string(),
    date: z.string(),
    checksum: z.string().optional()
});
//# sourceMappingURL=schemas.js.map